import { Button, Card } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionWithdrawals } from './SectionWithdrawals';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';

export default function BlindBoxWithdrawalsList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-withdrawals" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.withdrawRecords')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.withdrawRecords') },
          ]}
          action={
            <Button size="small" variant="outlined" onClick={() => setRefreshKey((k) => k + 1)}>
              {t('module.blindBox.refreshAll')}
            </Button>
          }
        />
        <Card variant="outlined" sx={{ ...SECTION_CARD_SX, mt: 2 }}>
          <SectionWithdrawals refreshKey={refreshKey} />
        </Card>
      </DashboardContent>
    </PermissionGuard>
  );
}
